import "../../../common/polyfills";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { EventList } from "./EventList";


export function MountEventList(props: any, el: Element) {
    ReactDOM.render(<EventList {...props} />, el);
}
